import { PersonHttpHelper, NO_DATA_MESSAGE, BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const getMemberCard = (personId, personaId, state, setState) => {
  if (state.isObjLoading !== true && personId && personaId && !state.message) {
    let newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      objData: [],
      message: 'Loading...'
    };
    setState(newState);

    const personIdForUrl = personId ? encodeURIComponent(personId) : 'NaN';
    const personaIdForUrl = personaId ? encodeURIComponent(personaId) : 'NaN';
    const url = `/Person/${personIdForUrl}/MemberCard/Persona/${personaIdForUrl}`;
    PersonHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: '',
          };
          setState(newState);
          return objData;
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  };
};

const MemberCardData = { INITIAL_STATE: BASIC_INITIAL_STATE, getMemberCard };
export default MemberCardData;